import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import styles from './button-group-skeleton.module.scss';

export function ButtonGroupSkeleton(): ReactElement {
  return <SkeletonBrick className={styles.button} radius={'8px'} theme={SkeletonBrickTheme.LIGHT} />;
}
